import React, { useEffect, useState } from 'react';
import {
    differenceInCalendarMonths,
    endOfDay,
    formatISO,
    isBefore,
    startOfDay,
    startOfToday,
} from 'date-fns';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './DateRangePickerOverlay.scss';
import BackDrop from '../../../partials/BackDrop';

export default ({startDate, endDate, onChange, translations, inline = false, setShowOverlay}) => {
    const [from, setFrom] = useState(new Date(startDate));
    const [to, setTo] = useState(new Date(endDate)); // Keep track of the last hovered day before the user clicks it
    const [selectedMonth, setSelectedMonth] = useState(from);
    const [isSelecting, setIsSelecting] = useState(false);

    // Update from and to when the start or end date changes
    useEffect(() => {
        if (formatISO(from) !== startDate) {
            const from = new Date(startDate);
            setFrom(from);

            // Update selected left month only if the new from is not the next month which would be on the right side
            if (differenceInCalendarMonths(from, selectedMonth) !== 1) {
                setSelectedMonth(from);
            }
        }
        if (formatISO(to) !== endDate) {
            setTo(new Date(endDate));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate]);

    function handleClick(day) {
        const date = startOfDay(day);

        if (!isSelecting || isBefore(date, from)) {
            setIsSelecting(true);
            setFrom(date);
            setTo(endOfDay(date));
        } else {
            setIsSelecting(false);
            const newTo = endOfDay(date);
            setTo(newTo);

            // We updated both start and end date, call onChange with the new values
            onChange(formatISO(from), formatISO(newTo));
        }
    }

    function handleHover(day) {
        if (!isSelecting) {
            return;
        }

        let date = startOfDay(day);

        if (isBefore(date, from)) {
            date = from;
        }

        setTo(date);
    }

    const closeOverlay = () => {
        setShowOverlay(false);
    };

    const classNames = require('classnames');
    let classes = classNames({
        'date-range-picker-overlay DayPickerInput-OverlayWrapper inline': inline,
        'date-range-picker-overlay DayPickerInput-OverlayWrapper': !inline,
    });

    return (
        <div className={classes}>
            <div className="DayPickerInput-Overlay">
                <button type="button" className="close-picker-btn" onClick={closeOverlay}>
                    <i className="la la-times" />
                </button>
                <DayPicker
                    className="Range"
                    months={translations && translations['months']}
                    weekdaysLong={translations && translations['weekdaysLong']}
                    weekdaysShort={translations && translations['weekdaysShort']}
                    labels={translations && translations['labels']}
                    firstDayOfWeek={1}
                    numberOfMonths={2}
                    fromMonth={new Date()}
                    disabledDays={{before: startOfToday()}}
                    month={selectedMonth}
                    selectedDays={{from, to: to}}
                    modifiers={{start: from, end: to}}
                    onDayClick={handleClick}
                    onDayMouseEnter={handleHover}
                />
            </div>
            <BackDrop click={closeOverlay} />
        </div>
    );
};
